import { useEffect, useState } from 'react';
import { useLocation } from '@tanstack/react-router';

const useCheckedItems = (initialState: string[] = []) => {
    const [checkedItems, setCheckedItems] = useState<string[]>(initialState);
    const location = useLocation();

    useEffect(() => {
        setCheckedItems([]);
    }, [location]);

    const toggleItem = (id: string) => {
        const currentIndex = checkedItems.indexOf(id);
        const newChecked = [...checkedItems];

        if (currentIndex === -1) {
            newChecked.push(id);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setCheckedItems(newChecked);
    };

    return { checkedItems, setCheckedItems, toggleItem };
};

export default useCheckedItems;
